import { StanModal } from '@/components';
import { StoreTheme } from '@/types/store';
import { useNavigate } from 'react-router-dom';
import { Themes } from '../constants/themeConstants';
import { useCustomizationStore } from '../stores/customizationStore';
import { ThemeItem } from './views/customizations/Themes';

export const LegacyThemeModal = () => {
    const navigate = useNavigate();
    const { updateStoreCustomizations } = useCustomizationStore();

    const applyTheme = (theme: StoreTheme) => {
        updateStoreCustomizations({ theme });
    };

    return (
        <>
            <div className='bg-neutral-white absolute inset-0 z-50' />
            <StanModal
                id='legacy-theme-modal'
                isOpen
                onClose={() => close()}
                hideCloseButton
                nonDismissible
                primaryActionLabel='Go back to dashboard'
                onPrimaryAction={() => navigate('/dashboard')}
            >
                <div className='flex flex-col items-center justify-center gap-2 text-center'>
                    <h2>Legacy theme detected</h2>
                    <p className='text-[var(--text-color-gray)]'>
                        We have detected that you are using a legacy theme. Before you continue, please upgrade to the
                        latest themes. saved.
                    </p>

                    <ul className='mt-4 grid w-full grid-cols-2 gap-2'>
                        {Themes.map((theme, index) => (
                            <li key={theme.id} className='h-50 overflow-hidden'>
                                <ThemeItem
                                    id={theme.id}
                                    name={theme.name}
                                    preview={theme.preview}
                                    key={theme.id}
                                    onClick={() => applyTheme(theme.id)}
                                    style={{ animationDelay: `${index * 0.05}s` }}
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            </StanModal>{' '}
        </>
    );
};
